'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBackspace = function TiBackspace(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 8.3h-16.7c-2.1 0-4.7 1.4-5.9 3.1l-4.4 6.1c-1 1.5-1.9 2.7-2 2.8-0.2 0.3-0.2 0.8 0 1.1 0.1 0 1 1.3 2 2.8l4.4 6.1c1.2 1.7 3.8 3 5.9 3h16.7c2.3 0 4.2-1.8 4.2-4.1v-16.7c0-2.3-1.9-4.2-4.2-4.2z m-3.8 16.4c0.6 0.6 0.6 1.7 0 2.3-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5l-3.8-3.8-3.8 3.8c-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.6-0.6-1.7 0-2.3l3.8-3.9-3.8-3.8c-0.6-0.6-0.6-1.7 0-2.3s1.7-0.7 2.4 0l3.8 3.8 3.8-3.8c0.7-0.7 1.7-0.7 2.4 0s0.6 1.7 0 2.3l-3.8 3.8 3.8 3.9z' })
        )
    );
};

exports.default = TiBackspace;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/backspace.js
// module id = 1810
// module chunks = 0